import { Helmet } from "react-helmet-async";
import AdSlot from "@/components/ads/AdSlot";

export default function AverageFemaleHeightUS() {
  const title = "Average Female Height in the US (Adults)";
  const description = "What is the average adult female height in the U.S.? Data-backed overview with links to the percentile calculator.";
  const url = (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/average-female-height-us";

  const articleLd = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    mainEntityOfPage: url,
    author: { "@type": "Organization", name: "HeightPercentile.com" },
    publisher: { "@type": "Organization", name: "HeightPercentile.com" },
  };
  const breadcrumbLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: (typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/" },
      { "@type": "ListItem", position: 2, name: title, item: url },
    ],
  };

  return (
    <main className="container mx-auto py-10 space-y-6">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={(typeof window !== 'undefined' ? window.location.origin : 'https://heightpercentile.com') + "/og-default.jpg"} />
        <script type="application/ld+json">{JSON.stringify(articleLd)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      </Helmet>

      <AdSlot slot="banner_top" className="mb-4" />
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_300px]">
        <article className="min-w-0">
          <h1>{title}</h1>
          <AdSlot slot="incontent_1" className="my-4" />
          <section className="prose prose-slate dark:prose-invert max-w-none">
            <p>
              For U.S. adult females, the average (mean) height typically falls around 162 cm (5 ft 4 in) in modern survey waves. Our calculator uses
              CDC/NHANES data and a weighted empirical CDF to estimate percentiles.
            </p>
            <p>
              Want your exact percentile? Try the calculator and select Female: <a className="underline" href="/">U.S. Adult Height Percentile Calculator</a>.
            </p>
            <h2>Notes and sources</h2>
            <ul>
              <li>Dataset: CDC/NCHS NHANES Body Measures (adults ≥20), weighted.</li>
              <li>Method: Weighted empirical CDF; see <a className="underline" href="/methodology">Methodology</a>.</li>
            </ul>
          </section>
        </article>
        <aside className="hidden lg:block">
          <AdSlot slot="sidebar_1" />
        </aside>
      </div>
    </main>
  );
}
